module.exports = __webpack_public_path__ + "img/ppt-3.c0acf6bc.png";